export enum AppointmentActivityType {
    Requested,
    Confirmed,
    Declined
}